import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../components/Button';
import Icon, { Icons } from '../../components/Icon/Icon';
import Input from '../../components/Input';
import PageHeader from '../../components/PageHeader';
import AppConfig from '../../config';
import { t } from '../../lang';
import RequestService from '../../services/RequestService';

import './CreateAddress.scss';

const { routes } = AppConfig;

const CreateAddress = () => {
	const [currency, setCurrency] = useState();
	const [addressLogin, setAddressLogin] = useState('');
	const [loading, setLoading] = useState(false);

	const externalId = useSelector(state => state.app.externalId);

	const availableCurrencies = useSelector(store => store.app.availableCurrencies);

	const [searchParams] = useSearchParams();
	const currencyId = searchParams.get('currencyId');

	const navigate = useNavigate();

	useEffect(() => {
		const currency = availableCurrencies.find(({ Id }) => Id === Number(currencyId));
		setCurrency(currency);
	}, []);

	const clearAddressLabel = () => {
		setAddressLogin('');
	};

	const createNewAddress = async () => {
		try {
			setLoading(true);
			const res = await RequestService.CreateAddress({
				Currency: currency.Symbol,
				Label: addressLogin,
				// MobileMerchantId: currencyId, //??
			});
			if (res.Status === 'Success') {
				const newAddress = res;

				navigate(
					{
						pathname: routes.address,
						search: createSearchParams({ currencyId: currency.Id }).toString(),
						hash: newAddress.AddressId.toString(),
					},
					{ replace: true }
				);
			}
		} catch {
		} finally {
			setLoading(false);
		}
	};

	const crossButton = (
		<Icon
			className='CreateAddress__cross-icon'
			onClick={clearAddressLabel}
			type={Icons.XMARK_CIRCLE_FILL}
			width={20}
			height={20}
		/>
	);

	return (
		<div className='CreateAddress'>
			<PageHeader header='Give a name' subheader='Enter a title to easily identify this address.' />

			<div className='CreateAddress__body'>
				<Input
					className='CreateAddress__label FormBlock'
					label='test'
					value={addressLogin}
					onChange={e => setAddressLogin(e.target.value)}
					postfix={addressLogin ? crossButton : ''}
				/>

				<Button
					className='CreateAddress__button'
					styleType='primary'
					disabled={addressLogin.length == 0}
					onClick={createNewAddress}
					loading={loading}
				>
					{t('Continue')}
				</Button>
			</div>
		</div>
	);
};

export default CreateAddress;
